import { useEffect } from 'react';
import { useEditor } from '../state/store';

/**
 * Auto-dismissing toast anchored to the bottom-right. Currently wired only
 * to the visual-editor save pipeline — success shows "Alterações salvas",
 * error bubbles the server's message. Keeping the component generic so
 * future flows (publish, theme sync) can reuse the same slot.
 */
export function SaveToast() {
  const status = useEditor((s) => s.saveStatus);
  const dismiss = useEditor((s) => s.setSaveStatus);

  // Auto-hide after a short delay for the success state only — errors stay
  // until the user clicks them away.
  useEffect(() => {
    if (status.state !== 'saved') return;
    const t = setTimeout(() => dismiss({ state: 'idle' }), 2800);
    return () => clearTimeout(t);
  }, [status.state, status.lastSavedAt, dismiss]);

  if (status.state !== 'saved' && status.state !== 'error') return null;

  const isError = status.state === 'error';
  return (
    <div
      role="status"
      aria-live="polite"
      className="lc-fade-in fixed bottom-5 right-5 z-[60] flex max-w-[320px] items-start gap-3 rounded-lg border bg-surface px-4 py-3 shadow-popover"
      style={{
        borderColor: isError ? '#fddcd8' : '#cbefd8',
      }}
    >
      <span
        className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-text-inverse"
        style={{ background: isError ? '#d72c0d' : '#008060' }}
      >
        {isError ? (
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
            <path d="M18 6 6 18M6 6l12 12" />
          </svg>
        ) : (
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 6 9 17l-5-5" />
          </svg>
        )}
      </span>
      <div className="min-w-0 flex-1 text-[13px] text-text">
        <div className="font-semibold">
          {isError ? 'Não foi possível salvar' : 'Alterações salvas'}
        </div>
        {isError ? (
          <div className="mt-0.5 text-[12px] text-text-subdued">
            {status.message || 'Tente novamente em alguns instantes.'}
          </div>
        ) : (
          <div className="mt-0.5 text-[12px] text-text-subdued">
            O tema foi publicado no servidor.
          </div>
        )}
      </div>
      <button
        onClick={() => dismiss({ state: 'idle' })}
        className="lc-btn-ghost flex h-6 w-6 items-center justify-center text-icon-subdued"
        aria-label="Dispensar"
      >
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <path d="M18 6 6 18M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
}
